export interface CalendarEventData {
  title: string;
  description?: string;
  start: Date;
  end: Date;
  location?: string;
}

export function generateICalendarContent(event: CalendarEventData): string {
  const formatDate = (date: Date) => {
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(date.getUTCSeconds()).padStart(2, '0');
    return `${year}${month}${day}T${hours}${minutes}${seconds}Z`;
  };

  const escapeText = (text: string) => {
    return text
      .replace(/\\/g, '\\\\')
      .replace(/,/g, '\\,')
      .replace(/;/g, '\\;')
      .replace(/\n/g, '\\n');
  };

  const uid = `${Date.now()}@deuce.app`;
  const dtstamp = formatDate(new Date());
  const dtstart = formatDate(event.start);
  const dtend = formatDate(event.end);

  let icalContent = `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//CourtVibe//CourtVibe//EN
CALSCALE:GREGORIAN
METHOD:PUBLISH
BEGIN:VEVENT
UID:${uid}
DTSTAMP:${dtstamp}
DTSTART:${dtstart}
DTEND:${dtend}
SUMMARY:${escapeText(event.title)}`;

  if (event.location) {
    icalContent += `\nLOCATION:${escapeText(event.location)}`;
  }

  if (event.description) {
    icalContent += `\nDESCRIPTION:${escapeText(event.description)}`;
  }

  icalContent += `\nEND:VEVENT
END:VCALENDAR`;

  return icalContent;
}

export function downloadCalendarEvent(event: CalendarEventData): void {
  const icalContent = generateICalendarContent(event);
  const blob = new Blob([icalContent], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  
  const link = document.createElement('a');
  link.href = url;
  link.download = `${event.title.replace(/\s+/g, '-').toLowerCase()}.ics`;
  document.body.appendChild(link);
  link.click();
  
  setTimeout(() => {
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }, 100);
}
